import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import {
  type CarrierLogisticsCredType,
  carrierLogistics,
} from '../standards.js'

export type pfegCredType = CarrierLogisticsCredType
export const pfegDocumentTypes = [
  'invoice',
  'proof-of-delivery',
  'signed-bol',
] as const satisfies readonly DocumentType[]

export const pfeg: CarrierDef<pfegCredType> = {
  name: 'Performance Freight Systems',
  scac: 'pfeg',
  ...carrierLogistics,
  engineLayers: ['documents', 'rating', 'profinder', 'pickup', 'tracking'],
  documentTypes: pfegDocumentTypes,
}
